import { useEffect } from "react";
import { queryKeys } from "@/constants";
import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash";
import { Project, Workbook, WorkbookTransform } from "@/models/workbook";
import { NotifyService } from "@/helpers/notify";
import discoveryApi from "@/services/discovery.api";

interface UseGetDiscoveryProps {
  enabledToastError?: boolean;
}

export const useGetDiscovery = (
  { enabledToastError = false }: UseGetDiscoveryProps = { enabledToastError: false }
) => {
  const query = useQuery({
    queryKey: [queryKeys.discovery],
    queryFn: async () => {
      const response = await discoveryApi.getAll();
      const workbooks: Workbook[] = isEmpty(response.data.workbooks)
        ? []
        : Object.values(response.data.workbooks);
      const projects: Project[] = isEmpty(response.data.projects)
        ? []
        : Object.values(response.data.projects);

      return { workbooks, projects } as WorkbookTransform;
    },
  });

  useEffect(() => {
    if (query.error) {
      // eslint-disable-next-line no-console
      console.error("useGetDiscovery", query.error.message);
      enabledToastError && NotifyService.error(query.error.message);
    }
  }, [query.error, enabledToastError]);

  return query;
};

export const useGetDiscoveryFull = (
  { enabledToastError = false }: UseGetDiscoveryProps = { enabledToastError: false }
) => {
  const query = useQuery({
    queryKey: [queryKeys.discoveryFull],
    queryFn: async () => {
      const response = await discoveryApi.getFull();
      const workbooks: Workbook[] = isEmpty(response.data.workbooks)
        ? []
        : Object.values(response.data.workbooks);
      const projects: Project[] = isEmpty(response.data.projects)
        ? []
        : Object.values(response.data.projects);

      return { workbooks, projects } as WorkbookTransform;
    },
  });

  useEffect(() => {
    if (query.error) {
      // eslint-disable-next-line no-console
      console.error("useGetDiscovery", query.error.message);
      enabledToastError && NotifyService.error(query.error.message);
    }
  }, [query.error, enabledToastError]);

  return query;
};
